import { useEffect, useState } from 'react';

/** Devuelve `value` con un retraso de `delayMs` — para no disparar una query
 * por cada tecla en inputs de texto. */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(t);
  }, [value, delayMs]);
  return debounced;
}
